/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EstimatedLaborCostDto } from '../../models/estimated-labor-cost-dto';

export interface GetEstimatedLaborCost$Params {
  id: string;
}

export function getEstimatedLaborCost(http: HttpClient, rootUrl: string, params: GetEstimatedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedLaborCostDto>> {
  const rb = new RequestBuilder(rootUrl, getEstimatedLaborCost.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EstimatedLaborCostDto>;
    })
  );
}

getEstimatedLaborCost.PATH = '/v0/estimatedLaborCost/{id}';
